import { buildConnectionUrl, buildMessage } from './utils';
export function makeReturningUserTracker(routeMap, eventClient, timeInstrumentationService) {
  return function trackReturningUser(_ref) {
    let {
      hostUrl,
      hash,
      page,
      options,
      returningUser
    } = _ref;

    const emitConnectionEvent = () => eventClient.emit('frontend_events', buildMessage({
      type: 'user-connected',
      hash,
      page,
      returningUser
    }));

    const emitIdleEvent = () => eventClient.emit('frontend_events', buildMessage({
      type: 'user-idle',
      hash,
      page,
      returningUser
    }));

    timeInstrumentationService.init(options, emitIdleEvent);
    eventClient.connect(buildConnectionUrl(routeMap, hostUrl, page, hash), err => console.error(err), emitConnectionEvent);
  };
}
//# sourceMappingURL=make-returning-user-tracker.js.map